module.exports = __webpack_public_path__ + "static/media/MarketingCommercial.8f10b973.png";